import React, { useMemo } from 'react';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import { useBankTransferDetailsModal } from '../../../../../billing-and-payments/components/BankTransferDetailsModal/useBankTransferDetailsModal';
import { PAYMENT_PROVIDER_NAME } from '../../../../../billing-and-payments/config/PaymentProviderName';
import { isBankTransfer } from '../../../../../billing-and-payments/config/PaymentType';
import { PAYMENT_STATUS_TYPE } from '../../../../../billing-and-payments/config/paymentStatusConsts';
import ActionableTextCellRenderer from './ActionableTextCellRenderer';
import ActionsCellRenderer from './ActionsCellRenderer';

export const PaymentMethodCellRenderer = ({ data, context, valueFormatted, ...rest }) => {
    context.dispatch = noop;
    const { paymentMethod, paymentStatus, totalAmount, currency, bankTransfer } = data;
    const paymentProvider = useMemo(
        () => (bankTransfer?.url ? PAYMENT_PROVIDER_NAME.STRIPE : PAYMENT_PROVIDER_NAME.KG_INICIS),
        [bankTransfer]
    );
    const { openModal: openBankTransferDetailsModal } = useBankTransferDetailsModal();
    const onBankTransferClick = async () => {
        await openBankTransferDetailsModal({
            vendor: paymentProvider,
            amount: totalAmount,
            currency,
            bankTransfer,
            paymentStatus,
        });
    };

    const { url, virtualAccountBankCode, virtualAccountNumber, virtualAccountHolderName, virtualAccountExpiryInUtc } =
        bankTransfer || {};

    if (isBankTransfer(paymentMethod)) {
        if (paymentStatus === PAYMENT_STATUS_TYPE.PENDING_FUNDS || paymentStatus === PAYMENT_STATUS_TYPE.PAID) {
            if (
                url ||
                (virtualAccountBankCode &&
                    virtualAccountNumber &&
                    virtualAccountHolderName &&
                    virtualAccountExpiryInUtc)
            ) {
                return (
                    <ActionableTextCellRenderer clickAction={onBankTransferClick} context={context} {...rest}>
                        {valueFormatted}
                    </ActionableTextCellRenderer>
                );
            }
        }
    }

    return [valueFormatted];
};

PaymentMethodCellRenderer.propTypes = {
    /** row data which is injected by the grid */
    data: PropTypes.object,
    ...ActionsCellRenderer.propTypes,
};
